import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { appGetLocale, appPathPrefix, isMobileAspectRatio } from '../helpers/appHelper';
import { yamazaki_red } from '../styles/color';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const dispatch = useDispatch();
    const headerRef = useRef(null);
    const appLanguage = appGetLocale();
    const isEng = appLanguage === 'en';
    const location = useLocation();
    const prefix = appPathPrefix();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isMobile = isMobileAspectRatio();

    useEffect(() => {
        const handleResize = () => {
            if (headerRef.current) {
                dispatch({ type: 'SET_HEADER_HEIGHT', payload: headerRef.current.clientHeight });
            }
        };

        if (headerRef.current) {
            dispatch({ type: 'SET_HEADER_HEIGHT', payload: headerRef.current.clientHeight });
        }

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [dispatch]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const Logo = () => (
        <a href={prefix + "/"}>
            <foreignObject x={isEng?"335":"367"} y="56" width="295.976" height="61.263" />
            <g transform={isEng?"translate(335 56)":"translate(367 56)"}>
                <g clipPath="url(#clip-path)">
                    <path d="M25.436,61.263C11.41,61.263,0,47.521,0,30.631S11.41,0,25.436,0,50.872,13.741,50.872,30.631,39.461,61.263,25.436,61.263m0-60.571C11.792.692.691,14.122.691,30.631s11.1,29.94,24.745,29.94S50.181,47.14,50.181,30.631,39.08.692,25.436.692" fill="#edc300" />
                    <path d="M31.194,65.02c-13.09,0-23.74-13.036-23.74-29.06S18.1,6.9,31.194,6.9s23.74,13.036,23.74,29.06-10.65,29.06-23.74,29.06m0-57.774C18.294,7.246,7.8,20.127,7.8,35.96S18.294,64.674,31.194,64.674,54.587,51.793,54.587,35.96,44.093,7.246,31.194,7.246" transform="translate(-5.758 -5.329)" fill="#edc300" />
                    <path d="M47.836,26.206A28.868,28.868,0,0,1,58.448,48.992c0,16-8.985,25.1-17.819,25.885V69.933H37.377v4.882c-9.422-1.149-17.35-10.388-17.35-25.823,0-8.951,3.77-17.024,8.963-21.824C22.394,31.9,17.924,40.92,17.924,50.624c0,14.87,10.308,27.387,21.357,27.387,9.624,0,21.357-10.261,21.357-28.39,0-9.943-5.586-19.145-12.8-23.415" transform="translate(-13.845 -20.238)" fill="#edc300" />
                    <path d="M99.788,36.181l-.763-.84a9.027,9.027,0,0,1,0-12.137l.763-.84.763.84a9.027,9.027,0,0,1,0,12.137Z" transform="translate(-74.679 -17.27)" fill="#edc300" />
                    <path d="M77.974,78.366,76.833,78.1a9.944,9.944,0,0,1-7.349-10.764l.151-1.184,1.142.268a9.943,9.943,0,0,1,7.349,10.764Z" transform="translate(-53.613 -51.086)" fill="#edc300" />
                    <path d="M77.973,123.715l-1.142-.268a9.944,9.944,0,0,1-7.349-10.764l.151-1.184,1.142.268a9.943,9.943,0,0,1,7.349,10.764Z" transform="translate(-53.613 -86.107)" fill="#edc300" />
                    <path d="M77.861,169.041l-1.126-.264a9.813,9.813,0,0,1-7.253-10.622l.149-1.168,1.127.264a9.813,9.813,0,0,1,7.253,10.622Z" transform="translate(-53.613 -121.235)" fill="#edc300" />
                    <path d="M112.858,78.366,114,78.1a9.944,9.944,0,0,0,7.349-10.764l-.151-1.184-1.142.268a9.943,9.943,0,0,0-7.349,10.764Z" transform="translate(-87.001 -51.086)" fill="#edc300" />
                    <path d="M112.858,123.715l1.141-.268a9.944,9.944,0,0,0,7.349-10.764L121.2,111.5l-1.142.268a9.943,9.943,0,0,0-7.349,10.764Z" transform="translate(-87.001 -86.107)" fill="#edc300" />
                    <path d="M112.288,169.041l1.126-.264a9.813,9.813,0,0,0,7.253-10.622l-.149-1.168-1.127.264a9.813,9.813,0,0,0-7.253,10.622Z" transform="translate(-86.562 -121.235)" fill="#edc300" />
                    <path d="M248.968,38.761h8.222a3.64,3.64,0,0,1,3.182,1.873l9.15,16.471,9.132-16.469a3.64,3.64,0,0,1,3.183-1.876h7.586l-15.451,26.33V83.327h-9.195V65.091Z" transform="translate(-192.31 -29.934)" fill="#d6003a" />
                    <path d="M883.4,110.125c-1.643,1.869-2.265,2.508-5.748,6.343L872,122.7h14.672v6.447H862.995v-3.881a7.289,7.289,0,0,1,1.884-4.891l14.528-16.062h-10.2a6.235,6.235,0,0,1-6.214-6.219h17.873c2.711,0,5.067.756,5.757,3.77.577,2.518-.182,4.794-3.227,8.258" transform="translate(-666.602 -75.757)" fill="#d6003a" />
                    <path d="M1119.67,38.288V82.962h7.491V69.15l10.121,12.477a3.639,3.639,0,0,0,2.827,1.347h8.169l-13.569-16.091,12.616-14.974h-8.031a3.64,3.64,0,0,0-2.789,1.3l-9.559,11.407V41.931a3.642,3.642,0,0,0-3.641-3.643Z" transform="translate(-864.865 -29.568)" fill="#d6003a" />
                    <path d="M1265.569,98.1V129.15h7.117v-27.41a3.642,3.642,0,0,0-3.641-3.643Z" transform="translate(-977.562 -75.756)" fill="#d6003a" />
                    <path d="M1265.773,49.834l1.035-.243a9.014,9.014,0,0,0,6.662-9.758l-.137-1.073L1272.3,39a9.014,9.014,0,0,0-6.662,9.758Z" transform="translate(-977.562 -29.934)" fill="#d6003a" />
                    <path d="M568.475,104.331H562.6V129.15h-7.44V104.331H547.4V129.15h-7.342V98.1h30.109c7.588,0,7.523,5.479,7.523,5.479V129.15H570.34V106.636c0-1.62-.71-2.306-1.865-2.306" transform="translate(-417.16 -75.756)" fill="#d6003a" />
                    <path d="M744.663,98.1H727.841a6.232,6.232,0,0,0,6.23,6.235h9.648a1.521,1.521,0,0,1,1.571,1.511v2.7H736.7c-5.545,0-10.69,2.4-10.69,10.572,0,10.039,8.522,10.039,8.522,10.039h18.22V104.007s.108-5.911-8.087-5.911m.647,24.687h-8.672c-1.628,0-3.3-.692-3.3-3.713v-.859a3.108,3.108,0,0,1,3.3-3.3h8.672Z" transform="translate(-560.789 -75.756)" fill="#d6003a" />
                    <path d="M420.629,98.1H403.807a6.232,6.232,0,0,0,6.23,6.235H419.6a1.521,1.521,0,0,1,1.571,1.511v2.7h-8.5c-5.545,0-10.69,2.4-10.69,10.572,0,10.039,8.522,10.039,8.522,10.039h18.22V104.007s.108-5.911-8.087-5.911m.647,24.687H412.6c-1.628,0-3.3-.692-3.3-3.713v-.859a3.108,3.108,0,0,1,3.3-3.3h8.673Z" transform="translate(-310.496 -75.756)" fill="#d6003a" />
                    <path d="M1000.624,98.1H983.8a6.232,6.232,0,0,0,6.23,6.235h9.559a1.521,1.521,0,0,1,1.571,1.511v2.7h-8.5c-5.545,0-10.69,2.4-10.69,10.572,0,10.039,8.522,10.039,8.522,10.039h18.22V104.007s.108-5.911-8.087-5.911m.647,24.687H992.6c-1.628,0-3.3-.692-3.3-3.713v-.859a3.108,3.108,0,0,1,3.3-3.3h8.673Z" transform="translate(-758.502 -75.756)" fill="#d6003a" />
                </g>
            </g>
        </a>
    )

    const News = () => (
        <a href={prefix + "/news"}>
            <g transform={isEng ? "translate(715 66)" : "translate(760 66)"}>
                <rect width={isEng?"196":"135"} height="46" fill="none" />
                <text transform={isEng?"translate(34 34)":"translate(68 34)"} fontSize="25" className="header-tag" style={{ fontWeight: location.pathname === prefix + '/news' ? 'bold' : 'normal' }}>
                    <tspan x="-53.375" y="0" fill={location.pathname === prefix + '/news' ? yamazaki_red : 'black'}>
                        <FormattedMessage id={'header.news'} />
                    </tspan>
                </text>
                <path d="M0,0H110" transform="translate(12 43)" fill="none" stroke="#000" strokeWidth="2" strokeDasharray="0 1000" />
            </g>
        </a>
    )

    const Products = () => (
        <a href={prefix + "/products"}>
            <g transform={isEng ? `translate(995 66)` : `translate(985 66)`}>
                <rect width="135" height="46" fill="none" />
                <text transform="translate(68 34)" fontSize="25" className="header-tag" style={{ fontWeight: location.pathname === prefix + '/products' ? 'bold' : 'normal' }}>
                    <tspan x="-53.375" y="0" fill={location.pathname === prefix + '/products' ? yamazaki_red : 'black'}>
                        <FormattedMessage id={'header.product'} />
                    </tspan>
                </text>
                <path d="M0,0H110" transform="translate(12 43)" fill="none" stroke="#000" strokeWidth="2" strokeDasharray="0 1000" />
            </g>
        </a>
    )

    const Shops = () => (
        <a href={prefix + "/stores"}>
            <g transform={isEng ? "translate(1234 66)" : "translate(1209 66)"}>
                <rect width="135" height="46" fill="none" />
                <text transform="translate(68 34)" fontSize="25" className="header-tag" style={{ fontWeight: location.pathname === prefix + '/stores' ? 'bold' : 'normal' }}>
                    <tspan x="-53.375" y="0" fill={location.pathname === prefix + '/stores' ? yamazaki_red : 'black'}>
                        <FormattedMessage id={'header.shops'} />
                    </tspan>
                </text>
                <path d="M0,0H110" transform="translate(12 43)" fill="none" stroke="#000" strokeWidth="2" strokeDasharray="0 1000" />
            </g>
        </a>
    )

    const Recruit = () => (
        <a href={prefix + "/careers"}>
            <g transform={isEng ? "translate(1433 66)" : "translate(1434 66)"}>
                <rect width="135" height="46" fill="none" />
                <text transform="translate(68 34)" fontSize="25" className="header-tag" style={{ fontWeight: location.pathname.includes(prefix + '/careers') ? 'bold' : 'normal' }}>
                    <tspan x="-53.375" y="0" fill={location.pathname.includes(prefix + '/careers') ? yamazaki_red : 'black'}>
                        <FormattedMessage id={'header.recruit'} />
                    </tspan>
                </text>
                <path d="M0,0H110" transform="translate(12 43)" fill="none" stroke="#000" strokeWidth="2" strokeDasharray="0 1000" />
            </g>
        </a>
    )

    const AboutUs = () => (
        <a href={prefix + "/about_us"}>
            <g transform={isEng ? "translate(1652 66)" : "translate(1658 66)"}>
                <rect width="135" height="46" fill="none" />
                <text transform="translate(68 34)" fontSize="25" className="header-tag" style={{ fontWeight: location.pathname === prefix + '/about_us' ? 'bold' : 'normal' }}>
                    <tspan x="-53.375" y="0" fill={location.pathname === prefix + '/about_us' ? yamazaki_red : 'black'}>
                        <FormattedMessage id={'header.about_us'} />
                    </tspan>
                </text>
                <path d="M0,0H110" transform="translate(12 43)" fill="none" stroke="#000" strokeWidth="2" strokeDasharray="0 1000" />
            </g>
        </a>
    )

    const Language = () => (
        <Link to={{pathname: prefix+'/language'}} state={{ prevPath: location.pathname }}>
            <g transform="translate(1900 66)">
                <rect width="135" height="46" fill="none" />
                <text transform="translate(68 34)" fontSize="25">
                    <tspan x="-53.375" y="0" fill={appLanguage === 'zh-Hant' ? yamazaki_red : 'black'} fontWeight={appLanguage === 'zh-Hant' ? 'bold' : ''} className="hover-bold">
                        <FormattedMessage id={'header.languageChi'} />
                    </tspan>
                    <tspan x="-25.375" y="0">
                        |
                    </tspan>
                    <tspan x="-10.375" y="0" fill={appLanguage === 'en' ? yamazaki_red : 'black'} fontWeight={appLanguage === 'en' ? 'bold' : ''} className="hover-bold">
                        <FormattedMessage id={'header.languageEn'} />
                    </tspan>
                </text>
                <path d="M0,0H110" transform="translate(12 43)" fill="none" stroke="#000" strokeWidth="2" strokeDasharray="0 1000" />
            </g>
        </Link>
    )

    const MobileHeader = () => {
        const closeMenu = () => {
            setIsMenuOpen(false);
        };

        return (
            <div className="mobile-header">
                <div className='mobile-logo'>
                    <a href={prefix + "/"}>
                        <img src={prefix + '/images/mobile_logo.png'} />
                    </a>
                </div>
                <div onClick={toggleMenu} className="mobile-menu-toggle">
                    <img src={prefix+'/images/mobile_menu.png'} />
                </div>
                <div className={`mobile-menu-overlay ${isMenuOpen ? 'open' : ''}`} onClick={closeMenu}>
                    <img src={prefix+'/images/menu-close.png'} className="menu-close" onClick={closeMenu} />
                </div>
            </div>
        )
    }

    return (
        <header ref={headerRef} style={{ boxShadow: '0 5px 5px rgba(0, 0, 0, 0.161)' }}>
            <div className="web-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1920 89">
                    <defs>
                        <clipPath id="clip-path">
                            <rect width="1920" height="89" fill="none" />
                        </clipPath>
                    </defs>
                    <g>
                        <path d="M0,0H1920V89H0Z" fill="#fff" />
                        <g transform="translate(-120 -44)">
                            <Logo />
                            <Products />
                            <Shops />
                            <Recruit />
                            <AboutUs />
                            <News />
                            <Language />
                        </g>
                    </g>
                </svg>
            </div>
            {isMobile && 
                <>
                <MobileHeader />
                <nav className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
                    <ul>
                        <li>
                            <a href={prefix + "/"}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-home.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.home" />
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href={prefix + "/news"}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-news.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.news" />
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href={prefix + "/products"}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-product.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.product" />
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href={prefix + "/stores"}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-shop.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.shops" />
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href={prefix + "/careers"}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-recruit.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.recruit" />
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href={prefix + "/about_us"}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-about_us.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.about_us" />
                                </div>
                            </a>
                        </li>
                        <li>
                            <Link to={{pathname: prefix+'/language'}} state={{ prevPath: location.pathname }}>
                                <div className='mobile-menu-img'>
                                    <img src={prefix+'/images/menu-language.png'} />
                                </div>
                                <div className='mobile-menu-text'>
                                    <FormattedMessage id="header.languageChi" />
                                    |
                                    <FormattedMessage id="header.languageEn" />
                                </div>
                            </Link>
                        </li>
                    </ul>
                </nav>    
                </>
            }
        </header>
    );
};

export default Header;